import React from 'react';
import { AlertTriangle, AlertCircle, Info } from 'lucide-react';

const TaskPriorityBadge = ({ priority }) => {
  const isCritical = priority === 'critical';
  const isHigh = priority === 'high';
  const isMedium = priority === 'medium';
  const isLow = priority === 'low';

  if (isCritical) {
    return (
      <div className="flex items-center gap-1 px-2 py-0.5 bg-red-100 border border-red-300 rounded text-xs">
        <AlertTriangle className="w-3 h-3 text-red-700" />
        <span className="font-semibold text-red-800 uppercase">Critical</span>
      </div>
    );
  }

  if (isHigh) {
    return (
      <div className="flex items-center gap-1 px-2 py-0.5 bg-orange-100 border border-orange-300 rounded text-xs">
        <AlertCircle className="w-3 h-3 text-orange-700" />
        <span className="font-semibold text-orange-800 uppercase">High</span>
      </div>
    );
  }

  if (isMedium) {
    return (
      <div className="flex items-center gap-1 px-2 py-0.5 bg-yellow-100 border border-yellow-300 rounded text-xs">
        <Info className="w-3 h-3 text-yellow-700" />
        <span className="font-semibold text-yellow-800 uppercase">Medium</span>
      </div>
    );
  }

  // Low
  return (
    <div className="flex items-center gap-1 px-2 py-0.5 bg-gray-100 border border-gray-300 rounded text-xs">
      <Info className="w-3 h-3 text-gray-600" />
      <span className="font-semibold text-gray-700 uppercase">Low</span>
    </div>
  );
};

export default TaskPriorityBadge;
